/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CreateIcebreaker = lazyLoad(
  () => import('./index'),
  module => module.CreateIcebreaker,
);
